import { Link, useLocation, useNavigate } from "react-router-dom";
import { Calculator, Wallet, Beef, Users, LogIn, LogOut, Sliders, Coins } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { LOGO_URL } from "@/lib/feedModels";
import { Button } from "@/components/ui/button";

const NAV_ITEMS = [
  { to: "/", label: "Kalkulator", icon: Calculator, roles: null },
  { to: "/biaya", label: "Biaya Pakan", icon: Wallet, roles: ["admin"] },
  { to: "/data-sapi", label: "Data Sapi", icon: Beef, roles: ["admin", "pegawai"] },
  { to: "/users", label: "Kelola User", icon: Users, roles: ["admin"] },
  { to: "/hpp", label: "Harga Sapi", icon: Coins, roles: ["admin"] },
  { to: "/pengaturan", label: "Pengaturan", icon: Sliders, roles: ["admin"] },
];

export default function NavBar() {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const visible = NAV_ITEMS.filter(
    (item) => !item.roles || (user && item.roles.includes(user.role))
  );

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  return (
    <nav
      data-testid="navbar"
      className="no-print sticky top-0 z-30 bg-[#FBF3E8]/90 backdrop-blur border-b border-[#E0A988]/40"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-2.5 shrink-0" data-testid="nav-brand">
          <img src={LOGO_URL} alt="Sembada Satwa" className="w-14 h-14 object-contain" />
          <span className="font-display font-extrabold text-xl text-[#8A5230] hidden sm:block">
            Sembada Satwa
          </span>
        </Link>

        <div className="flex items-center gap-1 overflow-x-auto">
          {visible.map((item) => {
            const Icon = item.icon;
            const active = location.pathname === item.to;
            return (
              <Link
                key={item.to}
                to={item.to}
                data-testid={`nav-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={`flex items-center gap-1.5 px-3 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors ${
                  active
                    ? "bg-[#A06E4D] text-white"
                    : "text-[#7A4A28] hover:bg-[#F7E5D2]"
                }`}
              >
                <Icon className="w-4 h-4" />
                <span className="hidden md:inline">{item.label}</span>
              </Link>
            );
          })}
        </div>

        <div className="flex items-center gap-2 shrink-0">
          {user ? (
            <>
              <div className="text-right hidden sm:block">
                <p className="text-sm font-semibold text-[#7A4A28] leading-tight">{user.name}</p>
                <p className="text-[10px] uppercase tracking-wider text-[#A06E4D]">{user.role}</p>
              </div>
              <Button
                data-testid="btn-logout"
                onClick={handleLogout}
                variant="outline"
                size="sm"
                className="rounded-full border-[#E0A988]/70 text-[#A06E4D] hover:bg-[#F7E5D2]"
              >
                <LogOut className="w-4 h-4 sm:mr-1" />
                <span className="hidden sm:inline">Keluar</span>
              </Button>
            </>
          ) : (
            <Button
              data-testid="btn-login-nav"
              onClick={() => navigate("/login")}
              size="sm"
              className="rounded-full bg-[#A06E4D] hover:bg-[#8A5230] text-white"
            >
              <LogIn className="w-4 h-4 sm:mr-1" />
              <span className="hidden sm:inline">Login Admin</span>
            </Button>
          )}
        </div>
      </div>
    </nav>
  );
}
